var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/red_tick.9bd6e6a8.png","uri@2x": __webpack_public_path__ + "static/media/red_tick.eb99ed3d.png","uri@3x": __webpack_public_path__ + "static/media/red_tick.47c7046f.png",
    width: 10,
    height: 8
});